import { all, call, put, takeLatest } from 'redux-saga/effects';

import api from '../../../core/api';
import { getIngredientDrymatters } from './appIngredients.actions';

function* getIngredientDrymattersSaga(action: ReturnType<typeof getIngredientDrymatters.started>) {
  try {
    const result = yield call(api.ingredients.getIngredientDrymatters, action.payload);

    yield put(
      getIngredientDrymatters.done({
        params: action.payload,
        result,
      }),
    );
  } catch (error) {
    throw error;
  }
}

export function* watchAppIngredientsSaga() {
  yield all(yield takeLatest(getIngredientDrymatters.started, getIngredientDrymattersSaga));
}
